const CalculoAstecService = {
  parseValorMonetario(valor) {
    if (!valor && valor !== 0) return 0;
    if (typeof valor === "number") return valor;
    if (typeof valor === "string") {
      const semPrefixo = valor.replace("R$ ", "");
      const limpo = semPrefixo.replace(/[^\d,.-]/g, "");
      if (limpo.includes(",")) {
        const semMilhar = limpo.replace(/\./g, "");
        return parseFloat(semMilhar.replace(",", ".")) || 0;
      }
      return parseFloat(limpo) || 0;
    }
    return 0;
  },

  parsePercentual(valor) {
    if (valor === null || valor === undefined) return 0;
    if (typeof valor === "number") return valor;
    if (typeof valor === "string") {
      const str = valor
        .replace(" %", "")
        .replace(",", ".")
        .trim();
      return parseFloat(str) || 0;
    }
    return 0;
  },

  formatPercentual(valor) {
    if (valor === null || valor === undefined || valor === 0) return "0,00 %";
    const valorFormatado = valor.toFixed(2).replace(".", ",");
    return `${valorFormatado} %`;
  },

  calcularValorAstec(valorOrcado, percentual) {
    const v = this.parseValorMonetario(valorOrcado);
    let p = this.parsePercentual(percentual);
    p = Math.min(p, 100);
    if (v === 0 || p === 0) return 0;
    const res = v * (p / 100);
    return parseFloat(res.toFixed(2));
  },

  calcularPercentual(valorOrcado, valorAstec) {
    const v = this.parseValorMonetario(valorOrcado);
    const va = this.parseValorMonetario(valorAstec);
    if (v === 0 || va === 0) return 0;
    let p = (va / v) * 100;
    p = Math.min(p, 100);
    return parseFloat(p.toFixed(2));
  },

  criarControlador(component) {
    const self = this;
    let atualizandoInternamente = false;
    let timeoutId = null;
    let ultimoValorProcessado = null;
    let inicializando = false;

    return {
      setValoresIniciais(vlOrcado, perAstec, vlAstec) {
        inicializando = true;
        atualizandoInternamente = true;

        if (vlOrcado != null) {
          component.vlOrcado = self.parseValorMonetario(vlOrcado);
        }

        if (perAstec != null) {
          const num = parseFloat(perAstec.toString().replace(",", "."));
          component.perAstec = isNaN(num) ? 0 : num;
          ultimoValorProcessado = component.perAstec;

          if (component.percentualDisplay !== undefined) {
            component.percentualDisplay = self.formatPercentual(
              component.perAstec
            );
          }
        }

        if (vlAstec != null) {
          component.vlAstec = self.parseValorMonetario(vlAstec);
        } else if (
          perAstec != null &&
          component.vlOrcado > 0 &&
          component.perAstec > 0
        ) {
          component.vlAstec = self.calcularValorAstec(
            component.vlOrcado,
            component.perAstec
          );
        }

        component.$nextTick(() => {
          atualizandoInternamente = false;
          setTimeout(() => {
            inicializando = false;
          }, 100);
        });
      },

      onPercentualChange(valor) {
        if (inicializando) {
          return;
        }

        if (atualizandoInternamente) return;

        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        const valorString = String(valor).trim();
        if (
          valorString === "" ||
          valorString === "0,00 %" ||
          valorString === "0" ||
          valor === 0
        ) {
          atualizandoInternamente = true;
          component.perAstec = 0;
          component.vlAstec = 0;
          ultimoValorProcessado = 0;

          if (component.percentualDisplay !== undefined) {
            component.percentualDisplay = "0,00 %";
          }

          component.$nextTick(() => {
            atualizandoInternamente = false;
          });
          return;
        }

        timeoutId = setTimeout(() => {
          const pReal = self.parsePercentual(valor);

          if (pReal === ultimoValorProcessado) {
            return;
          }

          atualizandoInternamente = true;
          ultimoValorProcessado = pReal;

          const vOrcado = self.parseValorMonetario(component.vlOrcado);

          if (vOrcado > 0) {
            component.vlAstec = self.calcularValorAstec(vOrcado, pReal);
          } else {
            component.vlAstec = 0;
          }

          component.perAstec = pReal;

          component.$nextTick(() => {
            atualizandoInternamente = false;
          });
        }, 500);
      },

      onValorAstecChange(valor) {
        if (inicializando) {
          return;
        }

        if (atualizandoInternamente) return;
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        const valorString = String(valor).trim();
        if (
          valorString === "" ||
          valorString === "R$ 0,00" ||
          valorString === "0" ||
          valor === 0
        ) {
          atualizandoInternamente = true;
          component.vlAstec = 0;
          component.perAstec = 0;
          ultimoValorProcessado = 0;

          if (component.percentualDisplay !== undefined) {
            component.percentualDisplay = "0,00 %";
          }

          component.$nextTick(() => {
            atualizandoInternamente = false;
          });
          return;
        }

        const vOrcado = self.parseValorMonetario(component.vlOrcado);
        const vAstec = self.parseValorMonetario(valor);
        if (vOrcado === 0) {
          component.vlAstec = vAstec;
          return;
        }

        atualizandoInternamente = true;
        const novoP = self.calcularPercentual(vOrcado, vAstec);
        if (novoP !== component.perAstec) {
          component.perAstec = novoP;
          ultimoValorProcessado = novoP;

          if (component.percentualDisplay !== undefined) {
            component.percentualDisplay = self.formatPercentual(novoP);
          }
        }

        component.vlAstec = vAstec;

        component.$nextTick(() => {
          atualizandoInternamente = false;
        });
      },

      onValorOrcadoChange(valor) {
        if (inicializando) {
          return;
        }

        if (atualizandoInternamente) return;
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        const valorString = String(valor).trim();
        if (
          valorString === "" ||
          valorString === "R$ 0,00" ||
          valorString === "0" ||
          valor === 0
        ) {
          atualizandoInternamente = true;
          component.vlOrcado = 0;
          component.vlAstec = 0;

          component.$nextTick(() => {
            atualizandoInternamente = false;
          });
          return;
        }

        const vOrcado = self.parseValorMonetario(valor);
        const pReal = component.perAstec;

        atualizandoInternamente = true;
        component.vlOrcado = vOrcado;

        if (pReal > 0 && vOrcado > 0) {
          const novoVA = self.calcularValorAstec(vOrcado, pReal);
          component.vlAstec = novoVA;
        } else {
          component.vlAstec = 0;
        }

        component.$nextTick(() => {
          atualizandoInternamente = false;
        });
      },

      reset() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        atualizandoInternamente = true;
        component.vlOrcado = 0;
        component.perAstec = 0;
        component.vlAstec = 0;
        ultimoValorProcessado = 0;

        if (component.percentualDisplay !== undefined) {
          component.percentualDisplay = "0,00 %";
        }

        component.$nextTick(() => {
          atualizandoInternamente = false;
        });
      }
    };
  }
};

export default CalculoAstecService;
